import emojiRegex from 'emoji-regex'

export const containEmoji = (text = ''): boolean => {
  const regex = emojiRegex()
  return !regex.test(text)
}
